import React, { useState } from 'react';
import { faUser, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '../../../contexts/AuthContext';
import AccountRow from './AccountRow';
import ChangeUsernameForm from './ChangeUsernameForm';
import ChangeEmailForm from './ChangeEmailForm';
import ChangePasswordForm from './ChangePasswordForm';
import styles from './Dashboard.module.scss';

export default function Dashboard() {
    const { user, logout } = useAuth();
    const [openRow, setOpenRow] = useState(null); // 'username' | 'email' | 'password' | null

    const toggleRow = (row) => setOpenRow((current) => (current === row ? null : row));
    const closeRow = () => setOpenRow(null);

    return (
        <div className={styles.dashboard}>
            <div className={styles.pageHeader}>
                <div>
                    <h1>Account</h1>
                </div>
                <button onClick={logout} className={`${styles.button} ${styles.logoutButton}`}>
                    Logout
                </button>
            </div>

            <div className={styles.settingsList}>
                <AccountRow
                    icon={faUser}
                    label="Username"
                    value={user.username}
                    open={openRow === 'username'}
                    onToggle={() => toggleRow('username')}
                >
                    <ChangeUsernameForm currentUsername={user.username} onSaved={closeRow}/>
                </AccountRow>

                <AccountRow
                    icon={faEnvelope}
                    label="Email"
                    value={user.email || 'Not set'}
                    open={openRow === 'email'}
                    onToggle={() => toggleRow('email')}
                >
                    <ChangeEmailForm currentEmail={user.email} onSaved={closeRow}/>
                </AccountRow>

                <AccountRow
                    icon={faLock}
                    label="Password"
                    value="••••••••"
                    open={openRow === 'password'}
                    onToggle={() => toggleRow('password')}
                >
                    <ChangePasswordForm onSaved={closeRow}/>
                </AccountRow>
            </div>
        </div>
    );
}
